(function() {
  var OPEN_DURATION = 480;
  var CLOSE_DURATION = 320;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  // ââ Inject all custom CSS from JS so it loads regardless of base.css cache ââ
  (function injectCSS() {
    var style = document.createElement('style');
    style.id = 'accordion-custom-styles';
    style.textContent = [
      /* Nav underline on desktop links */
      '.menu-list__link-title{position:relative}',
      '.menu-list__link-title::after{content:"";position:absolute;bottom:2px;left:10px;',
      'right:10px;height:1px;background-color:currentColor;transform:scaleX(0);',
      'transform-origin:right center;transition:transform 0.3s ease}',
      '.menu-list__link:hover .menu-list__link-title::after,',
      '.menu-list__link--active .menu-list__link-title::after{transform:scaleX(1);transform-origin:left center}',

      /* Smooth accordion â JS drives height+padding animation */
      '.accordion details>.details-content{overflow:hidden}',
      '.accordion details:not([open])>.details-content{',
      'display:block!important;height:0!important;',
      'padding-top:0!important;padding-bottom:0!important;padding-block-end:0!important}',

      /* Footer accordion: always open on desktop */
      '@media(min-width:750px){',
      'accordion-custom[data-disable-on-desktop="true"] .details-content{',
      'display:block!important;height:auto!important;block-size:auto!important;',
      'opacity:1!important;overflow:visible!important;padding-block:revert!important}}',

      /* DKK dropdown smooth animation */
      'dropdown-localization-component .localization-wrapper{',
      'display:block!important;opacity:0;visibility:hidden;translate:0 8px;pointer-events:none;',
      'transition:opacity 0.4s ease,translate 0.4s ease,visibility 0.4s ease}',
      'dropdown-localization-component .localization-wrapper:not([hidden]){',
      'opacity:1;visibility:visible;translate:none;pointer-events:auto}'
    ].join('');
    // Insert before any other stylesheets so it can be overridden but still sets baseline
    var firstSheet = document.head.querySelector('link[rel="stylesheet"],style');
    if (firstSheet) {
      document.head.insertBefore(style, firstSheet);
    } else {
      document.head.appendChild(style);
    }
  })();

  function initAlwaysOpenOnDesktop() {
    if (window.matchMedia('(min-width: 750px)').matches) {
      document.querySelectorAll('accordion-custom[data-disable-on-desktop="true"] details').forEach(function(d) {
        d.setAttribute('open', '');
      });
    }
  }

  function getBody(details) {
    for (var i = 0; i < details.children.length; i++) {
      if (details.children[i].tagName !== 'SUMMARY') return details.children[i];
    }
    return null;
  }

  // Reliable cross-browser reflow â getBoundingClientRect forces layout in Safari
  function forceReflow(el) {
    void el.getBoundingClientRect();
  }

  function animateOpen(details) {
    var body = getBody(details);
    if (!body) return;

    // Set [open] FIRST â still in the same JS task, no paint yet
    details.setAttribute('open', '');

    // Read ALL padding dimensions that might be set by theme (physical + logical)
    var cs = getComputedStyle(body);
    var naturalPT  = parseFloat(cs.paddingTop)      || 0;
    var naturalPB  = parseFloat(cs.paddingBottom)   || 0;  // also covers padding-block-end
    var targetH    = body.scrollHeight;

    // Clamp to zero â still in same JS task, no paint
    body.style.overflow       = 'hidden';
    body.style.height         = '0px';
    body.style.paddingTop     = '0px';
    body.style.paddingBottom  = '0px';
    body.style.paddingBlockEnd = '0px';
    body.style.transition     = 'none';

    // Force synchronous layout flush so the browser commits height:0 as the
    // "before-change style" for the upcoming CSS transition.
    forceReflow(body);

    // Defer target state to the next animation frame. The browser renders height:0
    // in the current frame; in the next frame it sees height change 0âtargetH and
    // starts the transition. Without this deferral, Chrome/Safari batch all the
    // synchronous style changes into one task and never animate from 0.
    requestAnimationFrame(function() {
      // Build transition string â always animate height; add padding if non-zero
      var parts = ['height ' + OPEN_DURATION + 'ms ' + EASING];
      if (naturalPT > 0) parts.push('padding-top '   + OPEN_DURATION + 'ms ' + EASING);
      if (naturalPB > 0) parts.push('padding-bottom ' + OPEN_DURATION + 'ms ' + EASING);
      body.style.transition = parts.join(', ');

      body.style.height        = targetH + 'px';
      body.style.paddingTop    = naturalPT + 'px';
      body.style.paddingBottom = naturalPB + 'px';
      // paddingBlockEnd will resolve to the same value as paddingBottom; let it follow
      body.style.paddingBlockEnd = '';

      var done = false;
      function cleanup() {
        if (done) return;
        done = true;
        body.removeEventListener('transitionend', cleanup);
        body.style.height        = 'auto';
        body.style.overflow      = '';
        body.style.transition    = '';
        body.style.paddingTop    = '';
        body.style.paddingBottom = '';
        body.style.paddingBlockEnd = '';
        delete details._animating;
      }
      body.addEventListener('transitionend', cleanup);
      setTimeout(cleanup, OPEN_DURATION + 100);
    });
  }

  function animateClose(details, callback) {
    var body = getBody(details);
    if (!body) { delete details._animating; if (callback) callback(); return; }

    var cs        = getComputedStyle(body);
    var currentH  = body.offsetHeight;
    var currentPT = parseFloat(cs.paddingTop)    || 0;
    var currentPB = parseFloat(cs.paddingBottom) || 0;

    // Freeze at current pixel dimensions (handles 'auto' height + any padding)
    body.style.overflow       = 'hidden';
    body.style.height         = currentH + 'px';
    body.style.paddingTop     = currentPT + 'px';
    body.style.paddingBottom  = currentPB + 'px';
    body.style.paddingBlockEnd = currentPB + 'px';
    body.style.transition     = 'none';

    forceReflow(body);

    var parts = ['height ' + CLOSE_DURATION + 'ms ' + EASING];
    if (currentPT > 0) parts.push('padding-top '   + CLOSE_DURATION + 'ms ' + EASING);
    if (currentPB > 0) parts.push('padding-bottom ' + CLOSE_DURATION + 'ms ' + EASING);
    body.style.transition = parts.join(', ');

    body.style.height         = '0px';
    body.style.paddingTop     = '0px';
    body.style.paddingBottom  = '0px';
    body.style.paddingBlockEnd = '0px';

    var done = false;
    function cleanup() {
      if (done) return;
      done = true;
      body.removeEventListener('transitionend', cleanup);
      details.removeAttribute('open');
      body.style.height         = '';
      body.style.overflow       = '';
      body.style.transition     = '';
      body.style.paddingTop     = '';
      body.style.paddingBottom  = '';
      body.style.paddingBlockEnd = '';
      delete details._animating;
      if (callback) callback();
    }
    body.addEventListener('transitionend', cleanup);
    setTimeout(cleanup, CLOSE_DURATION + 150);
  }

  document.addEventListener('click', function(e) {
    var summary = e.target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!(details instanceof HTMLDetailsElement)) return;
    if (!details.closest('.accordion')) return;
    e.preventDefault();
    if (details._animating) return;
    details._animating = true;

    if (details.open) {
      animateClose(details);
    } else {
      var accordion = details.closest('.accordion');
      var openOthers = accordion.querySelectorAll('details[open]');
      var closeCount = openOthers.length;
      if (closeCount === 0) {
        animateOpen(details);
      } else {
        openOthers.forEach(function(other) {
          other._animating = true;
          animateClose(other, function() {
            closeCount--;
            if (closeCount === 0) animateOpen(details);
          });
        });
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAlwaysOpenOnDesktop);
  } else {
    initAlwaysOpenOnDesktop();
  }
})();
